import React from 'react';

/**
 * Section of the form rendered as a table (#, Field, Fill). On mobile the rows stack.
 * Children are expected to be FieldRow elements.
 */
const FormSection = ({ title, children }) => (
    <section>
        <h2 className="psp-section__title">{title}</h2>
        <div className="psp-fields-table" role="group" aria-label={title}>
            <div className="psp-fields-table__head" aria-hidden="true">
                <span className="psp-fields-table__head-index">#</span>
                <span>Campo</span>
                <span>Preenchimento</span>
            </div>
            {children}
        </div>
    </section>
);

export const FieldRow = ({ index, label, required, htmlFor, children }) => (
    <div className="psp-field-row">
        <span className="psp-field-row__index">{index}</span>
        <label className="psp-field-row__label" htmlFor={htmlFor}>
            {label}
            {required && <span className="psp-required"> *</span>}
        </label>
        <div>{children}</div>
    </div>
);

export default FormSection;
